/**
 * Tenant Info API functions
 */

import type { TenantInfoData } from '@intellimon/shared/types';
import { tenantApi } from './client';

export async function getTenantInfo(): Promise<TenantInfoData> {
  const response = await tenantApi.get<TenantInfoData>('/tenant-info');
  return response.data;
}
